<template>
  <div class="co-market-box">
    <div class="market-tab main-bg">
      <div class="search">
        <!-- 搜索 -->
        <c-inputFind
          :promptText="$t('futures.market.text8')"
          :value="listfilterVal"
          @onchanges="inputchanges"
          name="trade"
          ref="tradeFind"
          className="search-input"/>
      </div>

      <div class="category-select-box">
        <template v-for="(item, index) in typeTabList">
          <span class="tab"
            :key="index"
            v-if="item.isShow"
            @click="changeTypeTab(item.id)"
            :class="item.classes">
            <i class="">{{item.text}}</i>
            <span class="selected blue-bg" v-if="contractSide === item.id"></span>
          </span>
        </template>
      </div>
    </div>

    <div class="co-market-symbol main-bg b-2-cl main-bd">
      <div class="thead a-3-bd">
        <span class="td-symbol">
          <!-- 合约  -->
          {{$t('futures.market.text1')}}
        </span>
        <span class="td-price" @click="sorteEvent('close')">
          <!-- 最新价 -->
          {{$t('futures.market.text2')}}
          <div :class="{selected: sortName === 'close'}" class="sorte">
            <!-- <svg v-if="sortName === 'close' && sortType === 'down'" class="icon icon-16" aria-hidden="true">
              <use xlink:href="#icon-a_17_1"></use>
            </svg>
            <svg v-else-if="sortName === 'close' && sortType === 'up'" class="icon icon-16" aria-hidden="true">
              <use xlink:href="#icon-a_17_2"></use>
            </svg>
            <svg v-else class="icon icon-16" aria-hidden="true">
              <use xlink:href="#icon-a_17"></use>
            </svg> -->
            <svg-icon v-if="sortName === 'close' && sortType === 'down'" class="icon icon-10" iconClass="icon-sort-down"></svg-icon>
            <svg-icon v-else-if="sortName === 'close' && sortType === 'up'" class="icon icon-10" iconClass="icon-sort-up"></svg-icon>
            <svg-icon v-else class="icon icon-10" iconClass="icon-sort"></svg-icon>
          </div>
        </span>
        <span class="td-rose" @click="sorteEvent('rose')">
          <!-- 涨跌幅 -->
          {{$t('futures.market.text3')}}
          <div :class="{selected: sortName === 'rose'}" class="sorte">
            <!-- <svg v-if="sortName === 'rose' && sortType === 'down'" class="icon icon-16" aria-hidden="true">
              <use xlink:href="#icon-a_17_1"></use>
            </svg>
            <svg v-else-if="sortName === 'rose' && sortType === 'up'" class="icon icon-16" aria-hidden="true">
              <use xlink:href="#icon-a_17_2"></use>
            </svg>
            <svg v-else class="icon icon-16" aria-hidden="true">
              <use xlink:href="#icon-a_17"></use>
            </svg> -->
            <svg-icon v-if="sortName === 'rose' && sortType === 'down'" class="icon icon-10" iconClass="icon-sort-down"></svg-icon>
            <svg-icon v-else-if="sortName === 'rose' && sortType === 'up'" class="icon icon-10" iconClass="icon-sort-up"></svg-icon>
            <svg-icon v-else class="icon icon-10" iconClass="icon-sort"></svg-icon>
          </div>
        </span>
      </div>
      <div class="tbody">
        <vue-scroll>
          <div>
            <template v-for="(item, index) in marketList">
            <div class="tr main-cl"
              v-if="item.type === contractSide"
              @click="switchSymbol(item.contractName)"
              :key="index"
              :class="{'a-4-bg': item.contractName === contractName}">
              <div class="bg a-4-bg"></div>
              <span class="td-symbol"> {{item.symbol}}</span>
              <span class="td-price">
                {{ fixPrice(item.close, item.priceFix)}}
              </span>
              <span class="td-rose"
                :class="roseClasses(item.rose)">
                {{item.rose | fixdRose}}%
              </span>
            </div>
            </template>
          </div>
        </vue-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import '@/components/modules/coTrade/style/market.scss';
import { fixD, myStorage } from '@/utils';
import { fixUpDownColor } from '@/utils/storage';

export default {
  mounted() {
    this.init();
  },
  props: {
    close: {
      default() {},
      type: Function,
    },
    isShow: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      // 币对列表
      // marketData: null,
      // 当前市场
      marketCurrent: null,

      // 行情数据
      WsData: {},
      // 当前合约市场
      currentTypeTab: 1,
      // 合约方向类型
      contractSide: 1,
      // 筛选
      listfilterVal: null,
      // 排序类别
      sortName: null,
      // 排序方向
      sortType: '',
      showTypeTabList0: false,
      showTypeTabList1: false,
      showTypeTabList2: false,
      showTypeTabList3: false,

    };
  },
  computed: {
    // 是否登录
    isLogin() {
      return this.$store.state.baseData.isLogin;
    },
    // 类型列表 USDT合约/币本位合约
    typeTabList() {
      return [
        {
          id: 1,
          text: this.$t('futures.market.text4'), // 'USDT合约',
          isShow: this.showTypeTabList1,
          classes: this.contractSide === 1 ? 'main-cl' : 'gray-cl',
        },
        {
          id: 0,
          text: this.$t('futures.market.text5'), // '币本位合约',
          isShow: this.showTypeTabList0,
          classes: this.contractSide === 0 ? 'main-cl' : 'gray-cl',
        },
        {
          id: 2,
          text: this.$t('futures.market.text6'), // '混合合约',
          isShow: this.showTypeTabList2,
          classes: this.contractSide === 2 ? 'a-12-bd b-1-cl' : 'b-2-cl',
        },
        {
          id: 3,
          text: this.$t('futures.market.text7'), // '模拟合约',
          isShow: this.showTypeTabList3,
          classes: this.contractSide === 3 ? 'a-12-bd b-1-cl' : 'b-2-cl',
        },
      ];
    },
    // 合约列表
    contractList() {
      return this.$store.state.future.contractList;
    },
    // 当前合约名称
    contractName() {
      return this.$store.state.future.contractName;
    },
    // 当前合约信息
    contractInfo() {
      return this.$store.state.future.contractInfo;
    },
    // 合约币对价格精度
    pricefix() {
      return this.$store.state.future.pricefix;
    },
    // 合约类型列表
    contractTypeText() {
      return this.$store.state.future.contractTypeText;
    },
    // 币对列表
    marketList() {
      let data = [];
      let text = '';
      if (this.contractList && this.contractList.length) {
        this.contractList.forEach((item) => {
          // 混合合约 || 模拟合约
          if (item.contractType !== 'E') {
            text = `-${item.marginCoin}`;
          } else {
            text = '';
          }
          const symbolName = item.symbol.replace('-', '');
          data.push({
            type: this.filterType(item),
            key: item.wsDatakey,
            symbol: `${symbolName}${text}`,
            contractName: item.contractName,
            sort: item.sort,
            close: this.WsData[item.wsDatakey] ? this.WsData[item.wsDatakey].close : '--',
            rose: this.WsData[item.wsDatakey] ? this.WsData[item.wsDatakey].rose : '--',
            priceFix: item.priceFix,
          });
        });
      }
      // 搜索
      if (this.listfilterVal) {
        const reg = new RegExp(this.listfilterVal, 'gim');
        data = data.filter(item => item.symbol.match(reg));
      }
      // 排序
      if (this.sortType === 'down') {
        data.sort((a, b) => parseFloat(b[this.sortName]) - parseFloat(a[this.sortName]));
      }
      if (this.sortType === 'up') {
        data.sort((a, b) => parseFloat(a[this.sortName]) - parseFloat(b[this.sortName]));
      }
      if (!this.sortType) {
        data.sort((a, b) => parseFloat(a.sort) - parseFloat(b.sort));
      }
      return data;
    },
    // 用户配置信息
    userConfig() {
      return this.$store.state.future.futureUserConfig;
    },

  },
  watch: {
    isShow() {
      this.listfilterVal = null;
    },
    contractInfo(val, old) {
      if (val && !old) {
        this.contractSide = this.filterType(val);
      }
    },
  },
  filters: {
    // 涨跌幅处理
    fixdRose(value) {
      if (value && value !== '--') {
        let slie = '';
        const val = parseFloat(value, 0);
        if (val > 0) { slie = '+'; }
        if (val < 0) { slie = '-'; }
        const num = Math.abs((value * 10000) / 100);
        return `${slie}${Number(num.toString().match(/^\d+(?:\.\d{0,2})?/))}`;
      }
      return value;
    },
  },
  methods: {
    // 筛选币对列表
    filterType(data) {
      // USDT 合约
      if (data.contractType === 'E' && data.contractSide === 1) {
        this.showTypeTabList1 = true;
        return 1;
      }
      // 币本位合约
      if (data.contractType === 'E' && data.contractSide === 0) {
        this.showTypeTabList0 = true;
        return 0;
      }
      // 模拟合约
      if (data.contractType === 'S') {
        this.showTypeTabList3 = true;
        return 3;
      }
      // 混合合约
      this.showTypeTabList2 = true;
      return 2;
    },
    // 最新价 精度处理
    fixPrice(value, fix) {
      return fixD(value, fix);
    },
    // 切换合约类型
    changeTypeTab(type) {
      this.contractSide = type;
      this.getReceiveCoupon();
    },
    // 搜索事件
    inputchanges(v) {
      this.listfilterVal = v;
    },
    // 币对排序
    sorteEvent(key) {
      this.$nextTick(() => {
        if (!this.sortName) {
          this.sortName = key;
          this.sortType = 'down';
        } else if (this.sortType === 'down') {
          this.sortName = key;
          this.sortType = 'up';
        } else if (this.sortType === 'up') {
          this.sortName = null;
          this.sortType = null;
        }
      });
    },
    // 切换币对
    switchSymbol(data) {
      let contractId;
      if (this.contractList && this.contractList.length) {
        this.contractList.forEach((item) => {
          if (data === item.contractName) {
            contractId = item.id;
          }
        });
      }
      myStorage.set('contractId', contractId);
      myStorage.set('contractName', data);
      myStorage.set('futuresMarketCurrent', this.contractSide);
      this.$bus.$emit('futuresMarketCurrent', this.contractSide);
      this.$store.dispatch('setActivePublicInfo');
      if (this.isLogin) {
        this.$store.dispatch('getUserConfig');
      }
      this.close();
    },
    // 涨跌幅 颜色 class
    roseClasses(data) {
      if (data && data !== '--') {
        const val = parseFloat(data, 0);
        if (val === 0) {
          return '';
        }
        return val > 0 ? fixUpDownColor('u-1-cl') : fixUpDownColor('u-4-cl');
      }
      return '';
    },

    init() {
      // 接收24小时行情数据
      this.$bus.$on('FUTURE_MARKET_DATA', (data) => {
        this.WsData = JSON.parse(data);
      });
      if (this.contractInfo) {
        this.contractSide = this.filterType(this.contractInfo);
      }
      this.getReceiveCoupon();
    },
    // 获去赠金
    getReceiveCoupon() {
      if (this.isLogin
        && this.userConfig
        && this.contractSide === 3
        && this.userConfig.openContract === 1
        && this.userConfig.couponTag === 0) {
        this.$store.dispatch('getReceiveCoupon');
      }
    },
  },
};
</script>
